import { Tooltip } from 'react-tooltip';
import styles from "../../pages/summary/summary.module.scss";

export const OverflowTooltipCell = ({ content, index, idPrefix, className, subContent }) => {
  const tooltipId = `${idPrefix}-tooltip-${index}`;

  return (
    <td className={className}>
      <div
        className={styles.content}
        data-tooltip-id={tooltipId}
        data-tooltip-place="top"
        data-tooltip-html={content}
      >
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>
      {subContent != null && subContent !== '' && (
        <div className={styles.subContent}>{subContent}</div>
      )}

      <Tooltip
        className="custom-tooltip"
        id={tooltipId}
        delayShow={200}
        offset={10}
        float={true}
      />
    </td>
  );
};

export default OverflowTooltipCell;